export const LOG_TYPES = {
  ACCOUNT: "account",
  STATUS: "status",
};
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'type' implicitly has an 'any' type.
export const options = (type, userID) => {
  const appDomain = `https://${window.location.hostname}`;
  const url = `${appDomain}/calendar?userId=${userID}&drawer=${type}`;
  return {
    URL: url,
    UserType: type,
    UserID: userID,
  };
};
